export default {
  helpCenterPageTitle: {
    id: 'hc_page_title',
    defaultMessage: 'Back Market – Help Center',
  },
  headingLine1: {
    id: 'hc_page_heading_line1',
    defaultMessage: 'Need help?',
  },
  headingLine2: {
    id: 'hc_page_heading_line2',
    defaultMessage: 'We got you.',
  },
}
